import React, { useState } from 'react';
import { Smile } from 'lucide-react';

interface EmojiReactionButtonProps {
  onEmojiSelect: (emoji: string) => void;
  isDarkMode: boolean;
}

const PRESET_EMOJIS = ['😂', '❤️', '🎉'];

export const EmojiReactionButton: React.FC<EmojiReactionButtonProps> = ({
  onEmojiSelect,
  isDarkMode,
}) => {
  const [showEmojis, setShowEmojis] = useState(false);

  const handleEmojiClick = (emoji: string) => {
    onEmojiSelect(emoji);
    setShowEmojis(false);
  };

  return (
    <div className="relative">
      {/* Main button */}
      <button
        onClick={() => setShowEmojis(!showEmojis)}
        className={`p-2 rounded-full transition-colors ${
          isDarkMode
            ? 'bg-gray-700 hover:bg-gray-600 text-gray-300'
            : 'bg-gray-200 hover:bg-gray-300 text-gray-700'
        }`}
        aria-label="React with emoji"
      >
        <Smile size={20} />
      </button>

      {/* Emoji picker popup */}
      {showEmojis && (
        <div
          className={`absolute bottom-full mb-2 right-0 flex gap-2 p-2 rounded-lg shadow-lg ${
            isDarkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'
          }`}
        >
          {PRESET_EMOJIS.map((emoji) => (
            <button
              key={emoji}
              onClick={() => handleEmojiClick(emoji)}
              className={`text-2xl p-2 rounded hover:scale-110 transition-transform ${
                isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
              }`}
              aria-label={`React with ${emoji}`}
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
